import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAppDispatch } from './redux/hooks';
import { setGuestMode } from './redux/slice/authModalSlice';
import { getGuestModeFromStorage } from './helper/helper';
import './App.css';
import Routing from './router/Routing';
import './styles/index.scss';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Toaster } from "react-hot-toast";
// import SplineAnimation from './components/common/SplineAnimation';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  const dispatch = useAppDispatch();

  // Restore guest mode from localStorage on app initialization
  useEffect(() => {
    const isGuestMode = getGuestModeFromStorage();
    if (isGuestMode) {
      dispatch(setGuestMode(true));
    }
  }, [dispatch]);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Toaster />
        {/* <div className="spline-floating">
          <SplineAnimation />
        </div>  */}
        <Routing />
      </QueryClientProvider>
    </>
  );
}

export default App;
